'use client'

import * as React from 'react'
import { mtc } from '../../../utils/style-helpers'
import { styles } from './styles'

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  className?: string
  error?: boolean
  placeholder?: string
}

/** An input for basic text based input types with no extra controls */
export const Textarea = ({
  className,
  error,
  placeholder,
  ...props
}: TextareaProps) => {
  return (
    <div className="w-full relative">
      <textarea
        placeholder={placeholder}
        className={mtc(styles({ error, className }))}
        {...props}
      />
    </div>
  )
}

Textarea.displayName = 'Textarea'
